import React from 'react';
import { SocialLinksJumbotron, GameBadgesList } from 'Roblox';
import metadataConstants from '../constants/metadataConstants';

const { SocialLinkJumbotronType } = SocialLinksJumbotron;

export const AboutTab = (): JSX.Element => {
  const { universeId = '' } = metadataConstants.metadataData() || {};
  return (
    <React.Fragment>
      <SocialLinksJumbotron type={SocialLinkJumbotronType.Game} targetId={universeId} />
      <GameBadgesList universeId={universeId} />
    </React.Fragment>
  );
};

export default AboutTab;
